import { useQueryClient } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import { meQueryOptions } from "./meQueryOptions";

// Сохраняет язык в профиль (`PATCH /api/me`) и кладёт ответ в кэш текущего пользователя.
export const useUpdateLocale = () => {
  const queryClient = useQueryClient();
  return $api.useMutation("patch", "/api/me", {
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryOptions().queryKey, user);
    },
  });
};
